var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUpload = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 60,
  height: 60,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13 2c-2.7614 0-5 2.23858-5 5v46c0 2.7614 2.2386 5 5 5h34c2.7614 0 5-2.2386 5-5V18.287c0-1.3074-.5121-2.5628-1.4265-3.4971L39.528 3.50289C38.5874 2.54173 37.2992 2 35.9544 2H13Z",
  stroke: "#005FF9",
  strokeWidth: 2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M29.3 25c0-.2761.2239-.5.5-.5h.4c.2761 0 .5.2239.5.5v3.3h-1.4V25Zm0 4.3h1.4v1.4h-1.4v-1.4Zm2.4 1.4v-1.4H35c.2761 0 .5.2239.5.5v.4c0 .2761-.2239.5-.5.5h-3.3Zm-2.4 1h1.4V35c0 .2761-.2239.5-.5.5h-.4c-.2761 0-.5-.2239-.5-.5v-3.3Zm-1-2.4v1.4H25c-.2761 0-.5-.2239-.5-.5v-.4c0-.2761.2239-.5.5-.5h3.3Z",
  fill: "#005FF9",
  stroke: "#005FF9"
})));
export { SvgUpload as ReactComponent };